var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Dialog } from "radix-ui";
import { useDisableRadixScrollLock } from "./useDisableRadixScrollLock";
import { useDataUiTheme } from "../utility/getDataUiTheme";
export var RadixDialogue = function (_a) {
    var open = _a.open, onOpenChange = _a.onOpenChange, overlayClassName = _a.overlayClassName, contentClassName = _a.contentClassName, _b = _a.useGeneratedDescriptionId, useGeneratedDescriptionId = _b === void 0 ? false : _b, children = _a.children;
    var uiTheme = useDataUiTheme();
    useDisableRadixScrollLock(open);
    var ariaDescribedByProps = useGeneratedDescriptionId
        ? {}
        : { "aria-describedby": undefined };
    return (React.createElement(Dialog.Root, { open: open, onOpenChange: onOpenChange, "data-ui-theme": uiTheme },
        React.createElement(Dialog.Portal, null,
            React.createElement(Dialog.Overlay, { className: overlayClassName }),
            React.createElement(Dialog.Content, __assign({ className: contentClassName }, ariaDescribedByProps), children))));
};
